export default "__VITE_ASSET__4dacd47c__"